import React from "react";
import { Plus, Upload } from "lucide-react";

function AskDoubt() {
  return (
    <div className="min-h-full bg-[#F4EFE8] px-3 py-4 sm:px-4 md:px-8 md:py-8">
      <div className="mx-auto w-full max-w-[1450px] space-y-8 md:space-y-16">
        {/* TOP CHAT BOX */}
        <section className="rounded-2xl bg-[#EAE3E7] p-4 sm:p-5 md:p-8 min-h-[280px] md:min-h-[420px] flex flex-col justify-between shadow-sm">
          <div className="flex justify-start sm:justify-end">
            <div className="max-w-full sm:max-w-[540px]">
              <h2 className="text-[#6B52C8] text-[22px] leading-8 sm:text-[28px] sm:leading-10 md:text-[34px] md:leading-[45px] font-normal text-left sm:text-right">
                Hi! I am here to help you find answers to your queries.
                How can I help you today?
              </h2>
            </div>
          </div>

          <div className="mt-6 sm:mt-10">
            <div className="bg-white border border-[#D7D1D1] rounded-xl min-h-[72px] sm:min-h-[90px] flex items-center gap-3 px-3 sm:px-5 shadow-sm">
              <button
                type="button"
                aria-label="Add query"
                className="min-w-[48px] h-[48px] sm:min-w-[60px] sm:h-[60px] rounded-full border-[4px] sm:border-[5px] border-[#202020] flex items-center justify-center shrink-0"
              >
                <Plus size={28} strokeWidth={3} className="text-[#202020] sm:hidden" />
                <Plus
                  size={38}
                  strokeWidth={3}
                  className="hidden sm:block text-[#202020]"
                />
              </button>

              <input
                type="text"
                placeholder="ask your query here.. our bot will help you find answers to your queries.."
                className="flex-1 bg-transparent outline-none text-[15px] sm:text-[20px] md:text-[26px] text-[#8f8f8f] placeholder:text-[#bebebe] min-w-0"
              />
            </div>
          </div>
        </section>

        {/* POST QUERY SECTION */}
        <section>
          <h2 className="text-[#6B52C8] text-[24px] sm:text-[30px] md:text-[44px] font-semibold mb-4 sm:mb-5">
            Post your query/ doubt
          </h2>

          <div className="bg-white border border-[#D7D1D1] rounded-xl min-h-[180px] md:min-h-[190px] flex flex-col md:flex-row md:items-stretch md:justify-between gap-4 p-4 sm:p-5 md:px-8 shadow-sm">
            <textarea
              placeholder="type here.. or upload image of your query"
              className="flex-1 resize-none bg-transparent outline-none text-[16px] sm:text-[22px] md:text-[34px] text-[#8f8f8f] placeholder:text-[#c8c8c8] min-h-[110px] md:min-h-0 md:pt-10"
            />

            <label className="cursor-pointer self-end md:self-center shrink-0 inline-flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-full border border-[#d7d1d1] bg-[#fafafa] hover:bg-white transition">
              <Upload
                size={24}
                strokeWidth={2.2}
                className="text-[#202020] sm:hidden"
              />
              <Upload
                size={32}
                strokeWidth={2.2}
                className="hidden sm:block text-[#202020]"
              />

              <input
                type="file"
                className="hidden"
              />
            </label>
          </div>
        </section>

        {/* PAST QUERIES SECTION */}
        <section className="space-y-4 sm:space-y-6">
          <h2 className="text-[#6B52C8] text-[24px] sm:text-[28px] md:text-[38px] font-semibold">
            Past queries
          </h2>

          <div className="hidden sm:grid grid-cols-[140px_1fr] md:grid-cols-[180px_1fr] gap-5">
            <h3 className="text-[20px] sm:text-[24px] md:text-[30px] font-medium text-black">
              Posted on
            </h3>
            <h3 className="text-[20px] sm:text-[24px] md:text-[30px] font-medium text-black">
              My Query/ Doubt
            </h3>
          </div>

          <div className="space-y-4 sm:space-y-8">
            {[1, 2].map((item) => (
              <div key={item} className="space-y-2 sm:space-y-3">
                <div className="grid grid-cols-1 sm:grid-cols-[140px_1fr] md:grid-cols-[180px_1fr] gap-3 sm:gap-5">
                  <div className="bg-white border border-[#D7D1D1] rounded-xl h-14 sm:h-[90px] flex items-center justify-center text-xs sm:text-sm text-gray-500">
                    08-Jun-2026
                  </div>

                  <div className="bg-white border border-[#D7D1D1] rounded-xl min-h-[64px] sm:h-[90px] flex items-center justify-between gap-3 px-4 sm:px-6">
                    <p className="text-[#222] text-[15px] sm:text-[18px] md:text-[24px] leading-6">
                      Unable to understand algebraic equations
                    </p>

                    <button type="button" aria-label="Expand response" className="shrink-0">
                      <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M6 9L12 15L18 9"
                          stroke="#202020"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>

                <button
                  type="button"
                  className="ml-0 sm:ml-[155px] md:ml-[205px] text-[15px] sm:text-[18px] md:text-[22px] underline text-[#202020]"
                >
                  + view responses
                </button>
              </div>
            ))}
          </div>

          <button
            type="button"
            className="mt-4 sm:mt-6 text-[18px] sm:text-[22px] md:text-[30px] underline text-[#202020]"
          >
            + view more
          </button>

          <div className="pt-8 sm:pt-12 md:pt-24 text-center text-[#202020] text-[14px] sm:text-[18px] md:text-[22px]">
            <p className="leading-7">
              Copyright © 2026
              <span className="mx-3 sm:mx-4 underline cursor-pointer">
                Terms of Use
              </span>
              <span className="underline cursor-pointer">
                Privacy Policy
              </span>
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default AskDoubt;
